module.exports = __webpack_public_path__ + "static/img/lading.da3b4e65.png";